(function (history) {
    var pushState = history.pushState;
    history.pushState = function (state, title, url) {
        if (typeof history.onpushstate == 'function') {
            history.onpushstate(url === null || url === void 0 ? void 0 : url.toString());
        }
        // ... whatever else you want to do
        // maybe call onhashchange e.handler
        // @ts-ignore
        return pushState.apply(history, arguments);
    };
})(window.history);
export default function useHistory() {
    return {
        pushUrl: (url) => {
            history.pushState(null, '', url);
            window.dispatchEvent(new HashChangeEvent('hashchange', {
                newURL: url,
                oldURL: window.location.href
            }));
        },
        setHistoryListener: (listener) => {
            history.onpushstate = url => {
                if (url) {
                    listener(url);
                }
            };
        }
    };
}
//# sourceMappingURL=useHistory.js.map